var React = require('react');

function AddNewAddress (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_ionic-ios-add-circle-outline","data-name":"Icon ionic-ios-add-circle-outline","transform":"translate(-3.375 -3.375)"},[React.createElement("path",{"id":"Path_255","data-name":"Path 255","d":"M20.377,15.044H16.646V11.313a.8.8,0,0,0-1.6,0v3.731H11.313a.767.767,0,0,0-.8.8.776.776,0,0,0,.8.8h3.731v3.731a.776.776,0,0,0,.8.8.8.8,0,0,0,.8-.8V16.646h3.731a.8.8,0,0,0,0-1.6Z","transform":"translate(-0.288 -0.288)","key":0}),React.createElement("path",{"id":"Path_256","data-name":"Path 256","d":"M15.375,4.99a10.381,10.381,0,1,1-7.344,3.04,10.316,10.316,0,0,1,7.344-3.04m0-1.615a12,12,0,1,0,12,12,12,12,0,0,0-12-12Z","transform":"translate(0 0)","key":1})]));
}

AddNewAddress.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = AddNewAddress;

AddNewAddress.default = AddNewAddress;
